module.exports = __webpack_public_path__ + "media/images/pinoy-va-finder-adb446de5f8f9f379b19463380242bbe.png";